export default {
  defaultOptions: {
    listViewLimit: 3,
    activeExclusiveMaxLimit: 8,
    minPressItems: 3,
    maxPressItems: 10,
    numPressSlidesToShowLg: 5,
    numPressSlidesToShowSm: 3,
    numPressSlidesToShowXs: 1,
    heroSoldListingsLimit: 10,
  },
  ourAdvantageSlides: [
    {
      bcVideoRefId: "WhatIf15",
      title:
        "Dont just get it on the market.<br>Get it the attention it deserves.",
      text: "For those who demand an elevated service like none other, there’s Sotheby’s International Realty. We’re the industry’s best agents, curating with incomparable attention to style and detail. We’re here for you to help sell your home at a scale you just won’t find anywhere else.",
    },
    {
      image: "our-advantage/wine-country.jpg",
      title: "What you can get only with us:",
      text: "Unrivaled marketing<br>Exclusive partnerships<br>Public relations powerhouse<br>Brand heritage and reputation<br>True global reach<br>Unmatched service",
    },
    {
      bcVideoRefId: "004584_SIR_PropertyJourney_Revamp_20211214_V03",
      title: "Expertise that reaches down the block and around the world.",
      text: "We distribute our listings to the most relevant websites around the globe and measure the impact with top analytic tools. Our worldwide partners include the most authoritative news, lifestyle, and financial voices, as well as real estate-centric websites. Nothing compares to the expertise and exposure we can offer.",
    },
    {
      image: `our-advantage/privileged-access.jpg`,
      title: `Privileged Access`,
      text: `Sotheby's has had a revered tradition of bringing the world's most cherished possessions to a global market since 1744. Sotheby's International Realty harnesses the worldwide recognition and prestige of the Sotheby's name along with exclusive marketing opportunities to introduce your home to the world's most qualified buyers.`,
    },
  ],
  press: {},
  showAuthModal: false,
  ...(window && window.__INITIAL_STATE__),
};



// WEBPACK FOOTER //
// ./src/store/initial-state.js